import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth-init-space/")({
  component: Home,
  beforeLoad: async () => {
    throw redirect({ to: "/stories" });
  },
});

function Home() {
  return <div className="text-center">Not used for now</div>;
}
